import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { getParcelTypeKey } from '@/parcels/helpers/helpers'

import { parcelTypeChip } from './constants'

const ParcelTypeChip = ({ type, isExchange }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const parcelType = parcelTypeChip[getParcelTypeKey(type, isExchange)]

  if (!parcelType) {
    return null
  }

  return (
    <Chip
      label={<Text type="bodySBold">{t(parcelType.label)}</Text>}
      color={theme.colors.info.onSurface}
      Icon={parcelType.Icon}
    />
  )
}

export default ParcelTypeChip
